import { EasterQuestsButtonLayout } from 'Layouts/Events/easter_2024/EasterQuestsButtonLayout';
import { EasterEventQuestsPopupLayout } from 'Layouts/Events/easter_2024/questsMenu/EasterEventQuestsPopupLayout';
import { EventStateHelper } from 'State/Events/EventStateHelper';
import { EventOfferHandler } from 'System/UI/Menu/EventOfferHandler';

// Function to check if the current event is active.
export const isCurrentEvent = EventStateHelper.isEasterEvent;

// Layout for quests in the current event.
export type EventQuestButtonLayout = EasterQuestsButtonLayout;
export const EventQuestButtonLayout = EasterQuestsButtonLayout;

export type EventQuestPopupLayout = EasterEventQuestsPopupLayout;

// Event character IDs for the current event.
export const EventCharacterIDs = {
    levelFail: 'Easter_Girl_FAIL',      // Default: 'character_failed_1'
    levelFailTNT: 'Easter_Girl_FAIL',   // Default: 'UI_TNT_Fail_Character'
    prelevel: 'Easter_Girl_PRELEVEL',   // Default: 'character_idle_1'
    hardHeader: 'Easter_Hard_header',   // Default: 'header_hard'
    hardTopList: 'top_list_hard',       // Default: 'top_list_hard'
}

// Event offer handler for the current event.
export const CurrentEventOfferHandler = EventOfferHandler;

// Event FTUX text for the current event.
export const CurrentEventFTUXString = 'EasterFTUXQuest';